// Pages
import ChooseDate from '@/views/test-drive/ChooseDate.vue';
import Preferences from '@/views/test-drive/Preferences.vue';
import PickRoute from '@/views/test-drive/PickRoute.vue';
import BeverageChoice from '@/views/test-drive/BeverageChoice.vue';
import ImportantFeatures from '@/views/test-drive/ImportantFeatures.vue';
import HomeAddress from '@/views/test-drive/HomeAddress.vue';
import PersonalInformation from '@/views/test-drive/PersonalInformation.vue';
import AnythingElse from '@/views/test-drive/AnythingElse.vue';
import RequestSubmitted from '@/views/test-drive/RequestSubmitted.vue';
import ErrorPage from '@/views/test-drive/ErrorPage.vue';
import TestDriveFromHome from '@/views/test-drive/TestDriveFromHome.vue';
import ChooseLocation from '@/views/test-drive/ChooseLocation.vue';
import RedirectRoute from '@/components/RedirectEntryRoute.vue';

export default [
  {
    path: '',
    component: RedirectRoute,
    meta: {
      skipImpression: true,
    },
  },
  {
    path: 'test-drive-from-home',
    name: 'test-drive-from-home-mobile',
    component: TestDriveFromHome,
    meta: {
      headerIcon: 'home',
      navInfo: {
        from: 0,
        to: 0,
      },
      numberOfSteps: 10,
      hideCarDetail: false,
    },
  },
  {
    path: 'choose-location',
    name: 'drive-choose-location-mobile',
    component: ChooseLocation,
    meta: {
      headerIcon: 'home',
      navInfo: {
        from: 0,
        to: 1,
      },
      numberOfSteps: 10,
      hideCarDetail: false,
    },
  },
  {
    path: 'choose-date',
    name: 'drive-choose-date-mobile',
    component: ChooseDate,
    meta: {
      headerIcon: 'home',
      navInfo: {
        from: 1,
        to: 2,
      },
      numberOfSteps: 10,
      hideCarDetail: false,
    },
  },
  {
    path: 'preferences',
    name: 'drive-preferences-mobile',
    component: Preferences,
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 2,
        to: 3,
      },
      numberOfSteps: 10,
      hideCarDetail: false,
    },
  },
  {
    path: 'pick-route',
    name: 'drive-pick-route-mobile',
    component: PickRoute,
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 3,
        to: 4,
      },
      numberOfSteps: 10,
      hideCarDetail: false,
    },
  },
  {
    path: 'important-features',
    name: 'drive-important-features-mobile',
    component: ImportantFeatures,
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 4,
        to: 5,
      },
      numberOfSteps: 10,
      hideCarDetail: false,
    },
  },
  {
    path: 'beverage-choice',
    name: 'drive-beverage-choice-mobile',
    component: BeverageChoice,
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 5,
        to: 6,
      },
      numberOfSteps: 10,
      hideCarDetail: false,
    },
  },
  {
    path: 'personal-information',
    name: 'drive-personal-information-mobile',
    component: PersonalInformation,
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 6,
        to: 7,
      },
      numberOfSteps: 10,
      hideCarDetail: false,
    },
  },
  {
    path: 'home-address',
    name: 'drive-home-address-mobile',
    component: HomeAddress,
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 7,
        to: 8,
      },
      numberOfSteps: 10,
      hideCarDetail: false,
    },
  },
  {
    path: 'anything-else',
    name: 'drive-anything-else-mobile',
    component: AnythingElse,
    meta: {
      headerIcon: 'back',
      navInfo: {
        from: 8,
        to: 9,
      },
      numberOfSteps: 10,
      hideCarDetail: false,
    },
    beforeEnter(to, from, next) {
      if (from.path.includes('request-submitted')) {
        next(false);
      } else {
        next();
      }
    },
  },
  {
    path: 'request-submitted',
    name: 'drive-request-submitted-mobile',
    component: RequestSubmitted,
    meta: {
      headerIcon: false,
      hideCarDetail: true,
    },
  },
  {
    path: 'error',
    name: 'drive-error-mobile',
    component: ErrorPage,
    meta: {
      hideCarDetail: true,
      headerIcon: 'home',
    },
  },
];
